import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog
} from "../types";

export const subscriberSection = "/subscriber/";
export const subscriberRefresh = "/subscriber/#";

export const subscriberListPath = subscriberSection;

export enum SubscriberListUrlSortField {
  name = "name",
  email = "email",
  subscribed = "subscribed",
  unsubscribed = "unsubscribed"
}

export enum SubscriberListUrlFiltersEnum {
  active = "active",
  query = "query"
}
export type SubscriberListUrlDialog = "remove" | "export" | TabActionDialog;
export type SubscriberListUrlFilters = Filters<SubscriberListUrlFiltersEnum>;
export type SubscriberListUrlSort = Sort<SubscriberListUrlSortField>;
export type SubscriberListUrlQueryParams = ActiveTab &
  SubscriberListUrlFilters &
  SubscriberListUrlSort &
  BulkAction &
  Dialog<SubscriberListUrlDialog> &
  Pagination;

export const subscriberListUrl = (params?: SubscriberListUrlQueryParams) =>
  subscriberListPath + "?" + stringifyQs(params);
export type SubscriberAddUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove-value"
  | "remove-values";
export type SubscriberUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove"
  | "remove-value"
  | "remove-values";
export type SubscriberAddUrlQueryParams = Dialog<SubscriberAddUrlDialog> &
  SingleAction;
export type SubscriberUrlQueryParams = BulkAction &
  Dialog<SubscriberUrlDialog> &
  SingleAction;
export const subscriberAddPath = urlJoin(subscriberSection, "add");

export const subscriberAddUrl = (params?: SubscriberAddUrlQueryParams) =>
  subscriberAddPath + "?" + stringifyQs(params);

export const subscriberPath = (id: string) => urlJoin(subscriberSection, id);
export const subscriberUrl = (id: string, params?: SubscriberUrlQueryParams) =>
  subscriberPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
